module.exports = __webpack_public_path__ + "img/antes_despues_335.240872c8.png";